// extracted by mini-css-extract-plugin
export default {"page":"ErrorPage-page-Jiv2O Page-page-TorHA","version":"ErrorPage-version-PGaC9"};